/**
 * EngagementMetrics - User Engagement & Product Metrics section
 */
import React from 'react';
import { Activity, TrendingUp, BarChart3, Target, Users } from 'lucide-react';
import { MetricCard, MetricSection, MetricSubsection, MetricGrid } from '../MetricCard';
import { formatValue } from '../analyticsFormatters';

export function EngagementMetrics({ snapshotData }) {
  const summary = snapshotData?.summary || {};
  
  return (
    <MetricSection title="User Engagement & Product Metrics">
      {/* Active Users */}
      <MetricSubsection title="Active Users">
        <MetricGrid cols={4}>
          <MetricCard
            icon={Activity}
            iconColor="bg-blue-100 dark:bg-blue-900/20"
            title="Daily Active Users"
            value={formatValue(summary.dailyActiveUsers || 0, 'number')}
            subtitle="last 24 hours"
          />
          <MetricCard
            icon={Activity}
            iconColor="bg-green-100 dark:bg-green-900/20"
            title="Weekly Active Users"
            value={formatValue(summary.weeklyActiveUsers || 0, 'number')}
            subtitle="last 7 days"
          />
          <MetricCard
            icon={Activity}
            iconColor="bg-purple-100 dark:bg-purple-900/20"
            title="Monthly Active Users"
            value={formatValue(summary.monthlyActiveUsers || 0, 'number')}
            subtitle="last 30 days"
          />
          <MetricCard
            icon={Target}
            iconColor="bg-orange-100 dark:bg-orange-900/20"
            title="Product Stickiness"
            value={formatValue(summary.productStickiness || 0, 'percentage')}
            subtitle="DAU/MAU ratio"
            subtitleColor="text-orange-600 dark:text-orange-400"
          />
        </MetricGrid>
      </MetricSubsection>

      {/* Engagement Insights */}
      <MetricSubsection title="Engagement Insights">
        <div className="bg-blue-50 dark:bg-transparent backdrop-blur-md rounded-lg p-4 border border-blue-200 dark:border-gray-700 mb-4">
          <p className="text-sm text-blue-700 dark:text-blue-300">
            Accurate tracking starts August 18, 2025 - Data reset to clean slate
          </p>
        </div>
        <MetricGrid cols={4}>
          <MetricCard
            icon={TrendingUp}
            iconColor="bg-green-100 dark:bg-green-900/20"
            title="Active Streaks"
            value={formatValue(summary.usersWithActiveStreaks || 0, 'number')}
            subtitle="2+ day streaks"
          />
          <MetricCard
            icon={Activity}
            iconColor="bg-blue-100 dark:bg-blue-900/20"
            title="Avg Current Streak"
            value={formatValue(summary.averageCurrentStreak || 0, 'decimal')}
            subtitle="consecutive days"
          />
          <MetricCard
            icon={BarChart3}
            iconColor="bg-purple-100 dark:bg-purple-900/20"
            title="Avg Longest Streak"
            value={formatValue(summary.averageLongestStreak || 0, 'decimal')}
            subtitle="best streak ever"
          />
          <MetricCard
            icon={Users}
            iconColor="bg-yellow-100 dark:bg-yellow-900/20"
            title="Highly Engaged"
            value={formatValue(summary.highlyEngagedUsers || 0, 'number')}
            subtitle="super users"
            subtitleColor="text-yellow-600 dark:text-yellow-400"
          />
        </MetricGrid>
      </MetricSubsection>
    </MetricSection>
  );
}

